<template>
  <abf-container>
    <v-layout mb-5>
      <v-flex xs12>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>far fa-handshake</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Partner Details</h4>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap class="py2">
                <v-flex xs12 sm6>
                  <image-edit-upload
                    :url.sync="updates.logo"
                    :optimalSize="'(optimal size 572px x 78px)'"
                    :path="'partner-images'"
                  ></image-edit-upload>
                </v-flex>
                <v-flex xs12 sm6>
                  <img :src="updates.logo" alt="Logo" class="responsive" />
                </v-flex>
              </v-layout>
            </v-container>
            <v-form lazy-validation>
              <v-container grid-list-md>
                <v-layout>
                  <v-flex xs12 sm6>
                    <v-layout wrap class="py-2" v-if="UserHasRole('Platform')">
                      <v-flex xs12>
                        <v-autocomplete
                          label="Parent account"
                          v-model="updates.parent_id"
                          :items="PartnersList"
                          item-text="name"
                          item-value="id"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap class="py-2">
                      <v-flex xs12 sm6>
                        <v-text-field label="Partner Name" v-model="updates.name"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-if="UserHasRole('Platform')"
                          label="Partner Subdomain"
                          v-model="subDomain"
                        ></v-text-field>
                        <p v-else>
                          <small style="color:rgba(0,0,0,0.54);" class="small pb-3 d-block">Website:</small>
                          <a target="_blank" :href="`https://${updates.sub_domain}.funderfinder.co.uk`"
                            >https://{{ updates.sub_domain }}.funderfinder.co.uk</a
                          >
                        </p>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap class="py-2" v-if="UserHasRole('Platform')">
                      <v-flex xs12 sm6>
                        <v-text-field
                          label="Referral Commission (%)"
                          v-model="updates.referral_commission_percentage"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6></v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 sm3 v-if="UserHasRole('Platform')">
                        <v-switch label="Elite Partner" v-model="updates.elite"></v-switch>
                      </v-flex>
                      <v-flex xs12 sm3 v-if="UserHasRole('Platform')">
                        <v-switch label="Branded Site" v-model="updates.branded_site"></v-switch>
                      </v-flex>
                      <v-flex xs12 sm3 v-if="UserHasRole('Platform')">
                        <v-switch label="Enabled" v-model="updates.enabled"></v-switch>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-switch label="Referral Emails" v-model="updates.referral_message"></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-layout wrap class="px-4 py-2" v-if="UserHasRole('Platform')">
                      <v-card class="ml-4 pa-2" elevation="1">
                        <v-card-title class="pb-0 mb-0">
                          <v-avatar class="secondary">
                            <v-icon dark>far fa-road</v-icon>
                          </v-avatar>
                          <div class="ml-3">
                            <h4 class="headline">Exclude Referrals from Journeys</h4>
                          </div>
                        </v-card-title>
                        <v-card-text>
                          <v-layout>
                            <v-flex xs12 sm6 v-for="journey in journeys" :key="journey.id">
                              <excluded-journey :journey="journey" :partner="SelectedPartner"></excluded-journey>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="updatePartner">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </abf-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import ImageEditUpload from './ImageEditUpload';
import AbfContainer from '../../Abf/AbfContainer';
import ExcludedJourney from './Widgets/ExcludedJourney';

export default {
  components: { AbfContainer, ExcludedJourney, ImageEditUpload },
  data: () => ({
    updates: {
      logo: null,
      name: null,
      sub_domain: null,
      referral_commission_percentage: null,
      elite: false,
      branded_site: false,
      enabled: false,
      referral_message: false,
      web_site_header: null,
      web_strapline: null
    }
  }),
  name: 'partner-details',
  computed: {
    ...mapGetters(['SelectedPartner', 'UserHasRole', 'PartnersList', 'JourneyTypes']),
    subDomain: {
      get() {
        return _.toLower(this.updates.sub_domain);
      },
      set(value) {
        this.updates.sub_domain = _.toLower(value);
      }
    },
    journeys() {
      const main = _.find(this.JourneyTypes, type => type.name === 'main');
      return _.isUndefined(main) ? [] : _.filter(main.journeys, journey => journey.default_journey === false);
    }
  },
  methods: {
    ...mapActions(['updateSelectedPartner', 'addNotification', 'getJourneyTypes']),
    updatePartner: function() {
      this.updateSelectedPartner(this.updates).then(() => {
        this.addNotification({
          text: `${this.updates.name} updated`
        });
      });
    }
  },
  mounted() {
    if (_.isNull(this.JourneyTypes[0].id)) {
      this.getJourneyTypes();
    }
  },
  watch: {
    SelectedPartner: {
      immediate: true,
      handler() {
        this.updates.logo = this.SelectedPartner.logo;
        this.updates.parent_id = this.SelectedPartner.parent_id;
        this.updates.name = this.SelectedPartner.name;
        this.updates.sub_domain = this.SelectedPartner.sub_domain;
        this.updates.referral_commission_percentage = this.SelectedPartner.referral_commission_percentage;
        this.updates.elite = this.SelectedPartner.elite;
        this.updates.branded_site = this.SelectedPartner.branded_site;
        this.updates.enabled = this.SelectedPartner.enabled;
        this.updates.referral_message = this.SelectedPartner.referral_message;
        this.updates.web_site_header = this.SelectedPartner.web_site_header;
        this.updates.web_strapline = this.SelectedPartner.web_strapline;
      }
    }
  }
};
</script>

<style scoped>
img.responsive {
  max-width: 100%;
}
</style>
